var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTentAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.64311 1.61412C9.43 1.25893 8.9693 1.14376 8.61412 1.35687C8.25893 1.56998 8.14376 2.03068 8.35687 2.38586L11.1254 7L2.57536 21.25H2C1.58579 21.25 1.25 21.5858 1.25 22C1.25 22.4142 1.58579 22.75 2 22.75H22C22.4142 22.75 22.75 22.4142 22.75 22C22.75 21.5858 22.4142 21.25 22 21.25H21.4246L12.8746 6.99999L15.6431 2.38586C15.8562 2.03068 15.741 1.56998 15.3859 1.35687C15.0307 1.14376 14.57 1.25893 14.3569 1.61412L12 5.54225L9.64311 1.61412ZM14.9177 21.25H9.08225L11.4589 14.9122C11.4955 14.8146 11.5888 14.75 11.693 14.75H12.307C12.4112 14.75 12.5045 14.8146 12.5411 14.9122L14.9177 21.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTentAlt);
export default __webpack_public_path__ + "static/media/tent-alt.0d8601d848f2c27599425eda84a507d2.svg";
export { ForwardRef as ReactComponent };